import styled, { css } from 'styled-components';
import { MobileScreen } from '../components/styles/ConstantMediaQuery';
import ColorConstants from '../constants/ColorConstants';
import LoadingSkeleton from '../components/loading/LoadingSkeleton';
import { getBackgroundColor } from '../colors/colors-variant.utils';

const getBorder = error => (error ? `1px solid ${ColorConstants.salmon}` : `1px solid ${ColorConstants['midnight-express']}`);
const getFontColor = error => (error ? `${ColorConstants.salmon}` : 'rgba(23,57,77,0.5)');

export const Wrapper = styled.div`
    margin: 0 0 7px 0;
    width: 100%;

    ${({ disabled }) => disabled && css`
        ${Row}{
            cursor: not-allowed;
            background-color: ${ColorConstants.GRAY_5};
        }

        ${Row} > * {
            cursor: not-allowed;
            background-color: ${ColorConstants.GRAY_5}; 
        }

        ${ErrorLabel}{
            background-color: white;
        }
    `}
`;

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    border: ${({ error }) => getBorder(error)};
    border-radius: 4px;
    min-height: 52px;
    align-items: center;
    padding: 0px 14px;
    width: 100%;

    ${({ color }) => `
        ${getBackgroundColor(color)}
    `}
`;

export const Label = styled.div`
    width: min-content;
    padding-left: 14px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    height: 100%;
    font-family: Helvetica;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: ${({ error }) => getFontColor(error)};
    background: inherit;
`;

export const ErrorLabel = styled.span`
    color: ${ColorConstants.salmon};
    font-family: Helvetica;
    font-size: 12px;
`;

export const WrapperTwoTextField = styled.div`
    display: flex;
    margin: 0 0 7px 0;
    
    & > ${Wrapper}{
        margin: 0;
    };

    & ${Wrapper}:first-child {
        margin-right: ${props => (!props.hasNoSeparator ? '1%' : 0)};
    };
    
    @media ${MobileScreen}{
        flex-direction: column;
        margin: 0px;
        
        & ${Wrapper} {
            margin: 0 0 7px 0;
        };
        
    };
`;

export const LabelWithBorder = styled(Label)`
    border-left: 1px solid ${ColorConstants['midnight-express']};
`;

export const Span = styled.span`
    color: ${ColorConstants['regal-blue']};
    font-family: Helvetica Neue, sans-serif;
    font-size: 15px;
    width: inherit;
`;

export const Input = styled.input`
    color: ${ColorConstants['regal-blue']};
    font-family: Helvetica Neue, sans-serif;
    font-size: 15px;
    width: 100%;
    
    ::placeholder,
    ::-webkit-input-placeholder {
        color: ${ColorConstants['regal-blue-20%']};
    }
    :-ms-input-placeholder {
        color: ${ColorConstants['regal-blue-20%']};
    }
`;

export const StyledLoadingSkeleton = styled(LoadingSkeleton)`
    width: 100%;
    height: 20px;
`;
